import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  const handleScrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 bg-white" data-id="element-58">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-59">
        <div className="inline-flex items-center justify-center p-4 bg-green-50 rounded-full mb-6" data-id="element-60">
          <ShieldCheck className="w-16 h-16 text-trust" data-id="element-61" />
        </div>

        <h2 className="text-3xl font-heading font-black text-charcoal mb-4" data-id="element-62">
          Garantía de 7 Días de Satisfacción
        </h2>

        <p className="text-lg text-charcoal-muted mb-8 max-w-2xl mx-auto" data-id="element-63">
          Estamos tan seguros de que este manual transformará tu forma de usar
          la Airfryer, que te damos 7 días para probarlo. Si aplicas el método y
          no logras resultados crocantes, te devolvemos el 100% de tu dinero.
          Sin preguntas.
        </p>

        <button onClick={handleScrollToOffer} className="bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white font-heading font-bold py-3 px-8 rounded-lg transition-colors uppercase tracking-wide" data-id="element-64">
          Probar sin riesgo
        </button>
      </div>
    </section>;
}